import React from 'react';
import {FoodDishesPage} from './WholeCode';
import WholeCode from './WholeCode';
const Fooddishes = () => {
    return (
        <>
        <WholeCode
        mainHeading="Food Recipe Online Industry"
        belowParagraph="What are you waiting for"
        btn="Get Started"
        cardHeading="Food Recipe"
        cardBelowHeading="Order Your Favourite"
        cardParagraph="Did you know, Collin Street Bakery has been baking the world’s best fruitcake since 1896? That’s right! Our world-famous DeLuxe® Fruitcake recipe has won our bakery global prestige and fame. We begin with our Business, Costa Rican pineapple, ripe cherries, and golden raisins."
        topHomepageclass="homePagepic"
    />
    <FoodDishesPage
    foodDishesImgSrc1="https://images.pexels.com/photos/461428/pexels-photo-461428.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc2="https://images.pexels.com/photos/3850213/pexels-photo-3850213.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" 
    foodDishesImgSrc3="https://images.pexels.com/photos/3872263/pexels-photo-3872263.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc4="https://images.pexels.com/photos/3186654/pexels-photo-3186654.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc5="https://images.pexels.com/photos/3026808/pexels-photo-3026808.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
    foodDishesImgSrc6="https://images.pexels.com/photos/3186654/pexels-photo-3186654.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
     />
    </>
    )
}
export default Fooddishes;